import { useContext, useEffect, useMemo, useState } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetLineViaUnitID } from "src/pages/Configuration/LinesAndNodesConfiguration/Lines/api/getLineViaUnitID";


// All your logic is here
export const useDataLinesTable = ({unitID}: useDataLinesTableProps) => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetDataLineViaUnitID []>([]);
  const getDataLinesViaUnitIDQuery = useGetLineViaUnitID({lineID: unitID})
  const { t } = useTranslation();

  const loadingDone = [getDataLinesViaUnitIDQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getDataLinesViaUnitIDQuery].filter(({ isError }) =>isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getDataLinesViaUnitIDQuery.data ? getDataLinesViaUnitIDQuery.data : [];

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "#",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "lineTypeName",
      columnDisplayName: "Είδος",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "provider",
      columnDisplayName: "Πάροχος",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "speed",
      columnDisplayName: "Ταχύτητα",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "usedBy",
      columnDisplayName: "Χρήση",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "hcNmsNum",
      columnDisplayName: "NMS",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "hcNum1",
      columnDisplayName: "HC Number A",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "coupleNumA1",
      columnDisplayName: "Αρ. Α ζεύγ. Α άκρου",
      visible: true,
      columnOrder: 8,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "coupleNumB1",
      columnDisplayName: "Αρ. Β ζεύγ. Α άκρου",
      visible: true,
      columnOrder: 9,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "hcNum2",
      columnDisplayName: "HC Number Β",
      visible: true,
      columnOrder: 10,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "coupleNumA2",
      columnDisplayName: "Αρ. Α ζεύγ. Β άκρου",
      visible: true,
      columnOrder: 11,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "coupleNumB2",
      columnDisplayName: "Αρ. Β ζεύγ. Β άκρου",
      visible: true,
      columnOrder: 12,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Γραμμής Data");
        break;
      case "edit":
        title = t("Επεξεργασία Γραμμής Data");
        break;
      case "delete":
        title = t("Διαγραφή Γραμμής Data");
        break;
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };



  useEffect(() => {
    getDataLinesViaUnitIDQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
  };
};

interface useDataLinesTableProps {
  unitID: number;
}
